module.exports = __webpack_public_path__ + "img/4.a7b98ac5.png";